
import detail from './detail'
import list from './list'
import contribute from './contribute'

const knowledge = {
  path: 'knowledge',
  component: resolve => require(['../../../../pages/modules/knowledge'], resolve),
  redirect: 'knowledge/list',
  children: [
    detail,
    list,
    contribute
  ],
  meta: {
    requireAuth: true
  }
}

export default knowledge
